/** 常量 */

// 默认颜色
export const DEFAULT_COLOR = '#001F97';

// 默认系统色彩
export const DEFAULT_SYSTEM_SWATCH_COLORS = [
  '#F2F3FF',
  '#D9E1FF',
  '#B5C7FF',
  '#8EABFF',
  '#618DFF',
  '#366EF4',
  '#0052D9',
  '#003CAB',
  '#002A7C',
  '#001A57',
];

// saturation-panel default rect
export const SATURATION_PANEL_DEFAULT_WIDTH = 343;
export const SATURATION_PANEL_DEFAULT_HEIGHT = 144;
export const SLIDER_DEFAULT_WIDTH = 303;

export const HUE_MAX = 360;
export const ALPHA_MAX = 100;
